import Admin, { hasRole, Role } from '@/models/Admin'
import Price from '@/models/Price'

export default class PricePolicy {
    viewAny(_admin: Admin): boolean {
        return true
    }

    view(admin: Admin, price: Price) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER,Role.STATION_MANAGER])
    }

    create(admin: Admin) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER])
    }

    update(admin: Admin, price: Price) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    restore(admin: Admin, price: Price) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    delete(admin: Admin, price: Price) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    forceDelete(_admin: Admin, _price: Price) {
        return false
    }
}
